import React from 'react';
import { Pagination } from '@platform/base';
import { getGlobalStorage, pageTo, setGlobalStorage, getSysFieldid } from '@platform/api';
import './index.less';

const DEFAULT_INFO = {
    pageSize: 0, //页容量
    pageIndex: 0, //当前页
    pageSizeOptions: [10, 20, 50, 100], //每页显示条数选项
    totalPage: 1,
    total: 0,
};

/**
 * NCC分页规则：
 * 1、在某页增/删数据时，当页条数不受pageSize影响（例如：pageSize是10，但通过增/删行，当页可显示11/9条数据）
 * 2、在某页增/删数据时，总页数不变
 * 3、切换分页时，更新总页数，如果删行导致pageIndex越界，取最后一页
 */
export default function usePagination(Table) {
    return class PaginationTable extends React.Component {

        state = { searchValue: '' }

        render() {
            let { paginationConfig = {}, checkboxConfig, locale, crossPageSelect, pkname, store } = this.props,
                { enable, pageIndex, pageSizeOptions, total, totalCount, pageSize, maxPageSize, paginationExtendRender } = paginationConfig,
                { enable: checkboxEnable, checkedKeys, allCheckedKeys, setSelectedNum, allBodyCheckedKeys } = checkboxConfig,
                { tableType } = store.getFlatInfo?.() || {};

            pageSize = Number(pageSize);
            pageIndex = Number(pageIndex);

            let totalSize = 0; // 这个是已选的total
            if (typeof setSelectedNum === 'function') {
                totalSize = setSelectedNum() ?? 0;
            } else if (crossPageSelect && pkname) {
                totalSize = tableType === "flat" ? allBodyCheckedKeys.size : allCheckedKeys.size;
            } else {
                totalSize = checkedKeys.size || 0;
                // 除去表头的-1
                if (checkedKeys.has(-1)) {
                    totalSize--;
                }
            }

            return (
                <>
                    <Table {...this.props} />
                    {enable &&
                        <div
                            className="table-pagination-wrapper"
                            fieldid={getSysFieldid("pagination-div")}
                        >
                            {checkboxEnable && <span className="pagination-info">
                                {locale['table0034'] /*已选*/}
                                <span>{totalSize}</span>
                                {locale['table0035'] /*条*/}
                            </span>}
                            {typeof paginationExtendRender === 'function' && paginationExtendRender()}
                            <span style={{ flex: 'auto' }}></span>
                            <Pagination
                                prev
                                next
                                maxButtons={5}
                                boundaryLinks
                                pageSize={pageSize}
                                total={total} //total和totalCount的区别是：total是刚进页面的总条数，不会改变。 totalCount随着页码的删除增加会改变(领域传来的)
                                showTotal={() => { // 这个是显示的total
                                    return <div className="pagination-total-info">
                                        {locale['table_pagination002']/** 共 */}
                                        <span>{totalCount}</span>
                                        {locale['table_pagination003']/** 条 */}</div>;
                                }}
                                current={pageIndex + 1}
                                onChange={this.handlePageIndexChange}
                                // items={Math.ceil(total / pageSize)}
                                showSizeChanger={true}
                                pageSizeOptions={pageSizeOptions}
                                maxPageSize={maxPageSize}
                                onPageSizeChange={(index, pageSize) => {
                                    // console.log(index, pageSize);
                                    this.handlePageSizeChange(pageSize);
                                }}
                            // dropdownAlign={{ points: ['bl', 'tl'] }}
                            />
                        </div>}
                </>
            );
        }

        handlePageSizeChange = nextPageSize => {
            const { pageIndex, pageSize, onChange } = this.props.paginationConfig || {};
            nextPageSize = Number(nextPageSize);
            if (nextPageSize !== pageSize) {
                onChange?.({ pageIndex, pageSize: nextPageSize });
            }
        }

        handlePageIndexChange = nextPageIndex => {
            nextPageIndex--;
            const { pageSize, pageIndex, onChange, totalCount } = this.props.paginationConfig || {};
            if (nextPageIndex !== pageIndex) {

                let maxPage = Math.ceil(totalCount / pageSize);
                nextPageIndex = Math.min(nextPageIndex, maxPage - 1);

                onChange?.({ pageIndex: nextPageIndex, pageSize });
            }
        }
    };
}

usePagination.displayName = 'usePagination';
usePagination.dependence = [];
usePagination.hooks = function () {
    return {
        getPaginationInfo: () => {
            let meta = this.store.meta;
            // 没有pageSize时从localStorage取
            let pageSize = Number(
                getPageSizeStorage( // localStorage里的
                    meta,
                    this.getConfig()?.id, // 主子拉平的pageSize是同步的
                    // this.store.paginationInfo?.pageSize || 
                    this.getComponent('Table')?.current?.props.paginationConfig?.defaultPageSize || // 领域传来的默认值
                    meta?.[this.getConfig()?.id]?.pagesize, // 模板上配的。拉平表随主表配置
                ),
            );
            return {
                ...DEFAULT_INFO,
                ...this.store.paginationInfo,
                pageSize,
            };
        },
        setPaginationInfo: info => {
            if (info) {
                info.hasOwnProperty('pageIndex') && (info.pageIndex = Number(info.pageIndex));
                info.hasOwnProperty('pageSize') && (info.pageSize = Number(info.pageSize));
                info.hasOwnProperty('total') && (info.total = Number(info.total));
                info.hasOwnProperty('totalPage') && (info.totalPage = Number(info.totalPage));

                this.store.paginationInfo = { ...DEFAULT_INFO, ...info };

                // this._updateInnerAllPks();
            } else {
                this.store.paginationInfo = { ...DEFAULT_INFO };
            }
            
            this.forceUpdate();
        },

    };
};
usePagination.propsGenerator = function (props) {
    let { paginationConfig, id } = props;
    if (!paginationConfig?.enable) {
        return props;
    }

    let { store } = props;

    let visibleRows = store.getVisibleRows(),
        allRowsInfo = store.getAllRowsInfo(),
        pageInfo = store.getPaginationInfo(),
        columns = store.getVisibleColumns(),
        meta = store.getMeta(),
        { tableType = 'parent' } = store.getFlatInfo?.() || {},
        totalCount = 0,
        metaPageSize = meta?.[id]?.pagesize;

    if (columns.length) {
        if (allRowsInfo?.allpks?.length || !visibleRows.length) { //当allpks为空时,要么是非跨页表格，要么跨页但无数据,若可见行为0，则totalCount也一定为0
            totalCount = tableType === "flat" ? allRowsInfo?.allbodypks?.length : allRowsInfo.allpks.length;
        } else if (pageInfo?.total) {
            totalCount = pageInfo.total;
        } else {
            totalCount = visibleRows.length;
        }
    }
    
    return {
        ...props,
        paginationConfig: {
            ...paginationConfig,
            ...pageInfo,
            totalCount, //总数据条数
            onChange: ({ pageIndex, pageSize }) => {
                let info = store.getPaginationInfo(),
                    totalPage = pageSize === 0 ? 1 : Math.ceil(totalCount / pageSize),
                    total;
                // 防止越界
                pageIndex = totalPage > 0 ? Math.min(Math.max(pageIndex, 0), totalPage - 1) : 0;
                if (tableType === "flat") {
                    total = allRowsInfo?.allbodypks?.length;
                } else {
                    total = allRowsInfo?.allpks ? allRowsInfo.allpks.length : info.total; // 前端更新总页数
                }
                store.setPaginationInfo({ ...info, pageIndex, pageSize, totalPage, total });
                setPageSizeStorage(meta, id, pageSize); // 主子拉平的pageSize是同步的
                paginationConfig?.onChange?.(store.getPaginationInfo());
            },
            pageSizeOptions: metaPageSize ? [...new Set([...DEFAULT_INFO.pageSizeOptions, Number(metaPageSize)].sort((a, b) => a - b))] : [...DEFAULT_INFO.pageSizeOptions],
        },
    };
};

function setPageSizeStorage(meta, moduleId, num) {
    if (!meta) {
        return;
    }

    let pageSizeStore = getGlobalStorage('localStorage', '_ncc_pagesize_store');
    if (pageSizeStore) {
        pageSizeStore = JSON.parse(pageSizeStore);
    } else {
        pageSizeStore = {};
    }
    let currentKey = getPageSizeStoreKey(meta, moduleId);
    if (currentKey) {
        pageSizeStore[currentKey] = num;
        setGlobalStorage('localStorage', '_ncc_pagesize_store', JSON.stringify(pageSizeStore));

    }
}

function getPageSizeStorage(meta, moduleId, defaultPageSize) {
    if (!meta) {
        return defaultPageSize || '100';
    }

    let currentKey = getPageSizeStoreKey(meta, moduleId);
    if (currentKey) {
        let pageSizeStore = getGlobalStorage('localStorage', '_ncc_pagesize_store');
        if (pageSizeStore) {
            pageSizeStore = JSON.parse(pageSizeStore);
            return pageSizeStore[currentKey] || defaultPageSize || '100';
        }
    }
    return defaultPageSize || '100';
}

function getPageSizeStoreKey(meta, moduleId) {
    let key = '';
    if (meta && meta[moduleId]) {
        let appcode = meta[moduleId].appcode || pageTo.getAppCode();
        let pagecode = meta[moduleId].pagecode || pageTo.getPageCode();
        let pageid = meta[moduleId].pageid || meta.pageid;
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;

        if (appcode && pagecode && pageid && moduleId) {
            key = appcode + '-' + pagecode + '-' + pageid + '-' + userid + '-' + moduleId;
        }
    }

    return key;

}